<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['patient_debts']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(contact)="data">
                  0{{ data.item.contact }}
                </template>
                <template #cell(debt)="data">
                  {{commas( data.item.debt) }}
                </template>
                </b-table>
              </div>
              <div class="mt-3">
                <strong>Total Debt: {{commas (totalDebt) }}</strong>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Patients Debts</span></center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
// import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { patientdebtorMethods, patientdebtorComputed } from "@/state/helpers";

export default {
  page: {
    title: "Patient Debts",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Patient Debts",
      items: [ {text: "Dashboard",to: "/",}, {text: "Patient Debts",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true, sortable: true },
          { key: 'patient_id', label: 'Patient ID', visible: true, sortable: true },
          { key: 'name', label: 'Name', visible: true },
          { key: 'contact', label: 'Contact', visible: true },
          { key: 'debt', label: 'Debt', visible: true },
        ],
    };
  },
  computed: {
    ...patientdebtorComputed,
    List() { return this.patientdebtors.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.patientdebtors.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.patientdebtors.length>0) { a=false;} else { a=true;} return a },
    totalDebt() { return this.Items.reduce((total, item) => total + item.debt, 0);  },
  },
  mounted() {
    this.fetchDebtors();
    this.TotalRows = this.patientdebtors.length;
    this.isBusy=false;
  },
  methods: {
    ...patientdebtorMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    commas(x) { return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
  },
};
</script>